import { BASE_URL } from './../config';

export async function getBlogCategories() {
  try {
    const response = await fetch(`${BASE_URL}/blog/categories` ,  {
      method:"POST"
    });
    const data = await response.json();
    if (!response.ok) return { success: false, message: data.message };
    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}

export async function getBlogPosts(categorySlug = '', page = 1) {
  try {
    const params = new URLSearchParams({ category: categorySlug, page });
    const response = await fetch(`${BASE_URL}/blog/posts?${params.toString()}`,{
      method:"POST"
    });
    const data = await response.json();
    if (!response.ok) return { success: false, message: data.message };
    return { success: true, data };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}

export function getCoverImageUrl(fileName) {
  if (!fileName) return null;
  return `${BASE_URL}/blog-covers/${fileName}`;
}

// دانلود مستقیم فایل مقاله با کلیک
export async function downloadBlogFile(postId, fileName) {
  try {
    const response = await fetch(`${BASE_URL}/blog/download/${postId}`);

    if (!response.ok) {
      const errData = await response.json().catch(() => null);
      return { success: false, message: errData?.message || 'خطا در دانلود فایل.' };
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'article';
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    return { success: false, message: 'خطا در ارتباط با سرور.' };
  }
}

export function formatFileSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getFileIcon(fileName) {
  if (!fileName) return 'insert_drive_file';
  const ext = fileName.split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'picture_as_pdf';
  if (['doc', 'docx'].includes(ext)) return 'description';
  if (['ppt', 'pptx'].includes(ext)) return 'slideshow';
  return 'insert_drive_file';
}